import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingView = ({ hasSmallLoadingSpinner = false }) => {
  return (
    <div
      className={classNames('loading-view-container', {
        'loading-view-container__small': hasSmallLoadingSpinner,
      })}
    >
      <CircularProgress size={40} thickness={3} />
    </div>
  );
};

LoadingView.propTypes = {
  hasSmallLoadingSpinner: PropTypes.bool,
};

export default LoadingView;
